import axios from "axios";

const SERVER = process.env.REACT_APP_NODEJS_SERVER_URL;

const authConfig = () => ({
  headers: {
    accessToken: localStorage.getItem("accessToken"),
  },
});

export const fetchEffectiveProductionChargeRouting = async (instanceId) => {
  const response = await axios.get(
    `${SERVER}/production/charge-routing/effective/${instanceId}`,
    authConfig()
  );
  return response?.data?.data || [];
};

export const fetchInstanceProductionChargeOverrides = async (instanceId) => {
  const response = await axios.get(
    `${SERVER}/production/charge-routing/instances/${instanceId}`,
    authConfig()
  );
  return response?.data?.data || [];
};

export const fetchProductionDepartments = async () => {
  const response = await axios.get(
    `${SERVER}/production/departments?active=true`,
    authConfig()
  );
  return response?.data?.data || [];
};

export const createInstanceProductionChargeOverride = async (instanceId, payload) => {
  const response = await axios.post(
    `${SERVER}/production/charge-routing/instances/${instanceId}`,
    payload,
    authConfig()
  );
  return response?.data?.data || null;
};

export const createGlobalProductionChargeRouting = async (payload) => {
  const response = await axios.post(
    `${SERVER}/production/charge-routing/global`,
    payload,
    authConfig()
  );
  return response?.data?.data || null;
};

export const updateProductionChargeRoutingMapping = async (id, payload) => {
  const response = await axios.patch(
    `${SERVER}/production/charge-routing/${id}`,
    payload,
    authConfig()
  );
  return response?.data?.data || null;
};

export const setProductionChargeRoutingMappingStatus = async (id, isActive) => {
  const response = await axios.post(
    `${SERVER}/production/charge-routing/${id}/status`,
    { isActive },
    authConfig()
  );
  return response?.data?.data || null;
};

export const previewInstanceProductionChargeRoutingImport = async (
  instanceId,
  { scopeType = "global" } = {}
) => {
  const response = await axios.post(
    `${SERVER}/production/charge-routing/legacy-import/preview`,
    {
      scopeType,
      instanceId: Number(instanceId),
    },
    authConfig()
  );
  return response?.data?.summary || null;
};

export const importInstanceProductionChargeRouting = async (
  instanceId,
  { scopeType = "global" } = {}
) => {
  const response = await axios.post(
    `${SERVER}/production/charge-routing/legacy-import`,
    {
      scopeType,
      instanceId: Number(instanceId),
    },
    authConfig()
  );
  return response?.data?.summary || null;
};
